import React, {useEffect} from 'react';
import { Edit, 
    useRecordContext,
    useDataProvider,
    Loading, 
    useGetOne, 
    useRefresh
} from 'react-admin';
import ModuleInputs from './ModuleInputs';
import { Typography } from '@mui/material';
import { useParams, useLocation, useH } from 'react-router-dom';


const ModuleEdit = (props) => {
    const params = useParams();
    let resource = "Module";
    if(params.id?.length > 10){
        resource = "ThisSpecificModuleVersion"
    }
    const { data, isLoading, error, } = useGetOne(resource, { id: params.id })
    if (isLoading) { return <Loading />; }
    if (error) { return <p>ERROR</p>; }
    if (data) {
        return (
            <Edit {...props} redirect="edit" title={<ModuleTitle {...props} />}>
                <ModuleInputs {...props} />
            </Edit>
        )
    }
    };

    // const location = useLocation();

    // useEffect(() => {
    //   // Access the data from the state parameter
    //   const dataFromRedirect = location.state?.data;
    //   console.log('Data from redirect:', dataFromRedirect);
    // }, [location]);

    // return (
    //             <Edit {...props} redirect="edit" title={<ModuleTitle {...props} />}>
    //                 <ModuleInputs {...props} />
    //             </Edit>
    //         )};


export default ModuleEdit;


export const ModuleTitle = () => {
    const record = useRecordContext();

    

    return record?.id? (
            <>
        <Typography>
        Module | <small>{record.moduleCode? record.moduleCode + " |" : ""}</small> <small>{record?.shortTitle}</small>
    </Typography>            
            </>
    ) : ("")
};